import { Theme } from '@mui/material/styles'

const muiCardContent = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        padding: '1.5rem'
      }
    }
  }
}

export default muiCardContent
